import VueRouter from 'vue-router';
import Router from './router';
import store from '../store';

const router = new VueRouter({
  mode: 'history',
  routes: Router,
  scrollBehavior(to, from, savedPosition) {
    // 滚动到锚点、设定偏移值44px
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 44 } };
    }
    // 表现浏览器的原生后退/前进、ignorePos为true时忽略
    if (!to.meta.ignorePos) {
      return savedPosition || { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // 缓存管理
  // 要实现实时变更数据都需写在activated钩子里,页面需要定义name属性且和路由上meta.keep属性匹配上
  // 注意缓存页面数据更新问题：思路-跳转前记录需要替换的商品id，回来后更新再删除该商品id并删除该id
  // 页面加入缓存
  if (to.meta.keep) {
    const includeList = store.state.vm.includeList;
    const isHas = includeList.includes(to.meta.keep);
    if (!isHas) {
      includeList.push(to.meta.keep);
      store.commit('INCLUDELIST', includeList);
    }
  }
  // 滑动方向管理
  const history = store.state.vm.history;
  const toIndex = history[to.path];
  const fromIndex = history[from.path];
  if (toIndex) {
    if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10)) {
      store.commit('DIRECTION', to.meta.action || from.meta.action ? 'in' : '');
    } else {
      store.commit('DIRECTION', to.meta.action || from.meta.action ? 'out' : '');
    }
  } else {
    const historyCount = ++store.state.vm.historyCount;
    store.commit('HISTORYCOUNT', historyCount);
    history[to.path] = historyCount;
    store.commit('HISTORY', history);
    store.commit('DIRECTION', to.meta.action || from.meta.action ? 'in' : '');
  }
  // 登录权限
  if (!to.meta.requireAuth) {
    next();
    return;
  }
  // 验证是否登录
  if (store.state.loginData) {
    next();
    return;
  }
  // 以上都不满足，跳转登录页
  store.commit('REDIRECT', to.fullPath);
  next({ path: '/login', query: { redirect: to.fullPath } });
});

router.afterEach((to) => {
  // 记录路由信息
  store.commit('ROUTE', to);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js